import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';
import { setDefault } from './utils';

export default function* listenSetDefault() {
  yield takeEvery(payoutActions.setDefault.toString(), setDefault);
}
